module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Major Characters in the Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Harley M. Hudson")]), _vm._v(", President of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Lucille")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Orrin Knox")]), _vm._v(", Secretary of State")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Beth")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Governor "), _c('i', [_vm._v("Edward M. Jason")]), _vm._v(" of California")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Ceil")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Patsy Jason Labaiya")]), _vm._v(", his sister")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Selena Jason Castleberry")]), _vm._v(", their aunt")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Valuela Jason Randall")]), _vm._v(", their aunt")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Herbert Jason")]), _vm._v(", their uncle")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Senator "), _c('i', [_vm._v("Robert Durham Munson")]), _vm._v(" of Michigan, Majority Leader of the United States Senate")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Dolly")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Senator "), _c('i', [_vm._v("Stanley Danta")]), _vm._v(" of Connecticut, Majority Whip of the Senate")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("The Speaker of the House")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Representative "), _c('i', [_vm._v("Cullee Hamilton")]), _vm._v(" of California")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Senator "), _c('i', [_vm._v("Lafe Smith")]), _vm._v(" of Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Representative "), _c('i', [_vm._v("J. B. “Jawbone” Swarthman")]), _vm._v(" of South Carolina, chairman of the House Foreign Affairs Committee")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Senator "), _c('i', [_vm._v("Tom August")]), _vm._v(" of Minnesota, chairman of the Senate Foreign Relations Committee")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Robert A. Leffingwell")]), _vm._v(", Director of the President’s Commission on Administrative Reform")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Walter Dobius")]), _vm._v(", a columnist")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Helen-Anne Carrew")]), _vm._v(", another columnist")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("The executive chairman of The Greatest Publication That Absolutely Ever Was")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Members of Walter’s world")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("The working press")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }, [_vm._v("AT THE UN")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("His Royal Highness "), _c('i', [_vm._v("Terence Wolowo Ajkaje")]), _vm._v(", 137th M’Bulu of Mbuele; “Terrible Terry”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("His Royal Highness "), _c('i', [_vm._v("Obifumatta Ajkaje")]), _vm._v(", his cousin; “Prince Obi”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Vasiliy Tashikov")]), _vm._v(", Ambassador of the U.S.S.R.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Krishna Khaleel")]), _vm._v(", Ambassador of India")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Lord "), _c('i', [_vm._v("Claude Maudulayne")]), _vm._v(", Ambassador of the United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Kitty")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Raoul Barre")]), _vm._v(", Ambassador of France")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Celestine")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("The Secretary-General")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Members of Walter’s world")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("The working press")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }, [_vm._v("AT THE CONVENTION")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Hal Knox")]), _vm._v(", son of the Secretary of State")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Crystal Danta Knox")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Mrs. "), _c('i', [_vm._v("Mabel Anderson")]), _vm._v(", widow of the late Senator Brigham Anderson of Utah")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Roger P. Croy")]), _vm._v(", National Committeeman from Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Mrs. "), _c('i', [_vm._v("Esmé Harbellow Stryke")]), _vm._v(", National Committeewoman from California")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Mrs. "), _c('i', [_vm._v("Mary Buttner Baffleburg")]), _vm._v(", National Committeewoman from Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Miss "), _c('i', [_vm._v("Lizzie Hanson McWharter")]), _vm._v(", National Committeewoman from Kansas")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Mrs. "), _c('i', [_vm._v("Anna Hooper Bigelow")]), _vm._v(", National Committeewoman from New Hampshire")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Joe Smitters")]), _vm._v(", "), _c('i', [_vm._v("Bill Smatters")]), _vm._v(", "), _c('i', [_vm._v("Bob Smutters")]), _vm._v(", "), _c('i', [_vm._v("John Smotters")]), _vm._v(", "), _c('i', [_vm._v("Buddy Smetters")]), _vm._v(": county chairmen")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Senator "), _c('i', [_vm._v("Fred Van Ackerman")]), _vm._v(" of Wyoming, spokesman for the Committee on Making Further Offers for a Russian Truce (COMFORT)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("LeGage Shelby")]), _vm._v(", national chairman of Defenders of Equality for You (DEFY)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Rufus Kleinfert")]), _vm._v(", Knight Kommander of the Konference on Efforts to Encourage Patriotism (KEEP)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Booker T. Saunders")]), _vm._v(", a hero")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("William Everett Hollister II")]), _vm._v(", another hero")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_c('i', [_vm._v("Frankly Unctuous")]), _vm._v(", an Anchor Man")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("Members of Walter’s world")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisPersonae"
  }, [_vm._v("The working press")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 75
// module chunks = 0